<template>
  <div class="vx-row">

    <div class="vx-col w-full">
      <vx-card title="System Pick List Manage">
        <vs-list>
<!--          <vs-list-item v-for="currency in currencies" :title="currency.code" :subtitle="currency.name"></vs-list-item>-->
        </vs-list>
      </vx-card>
    </div>
  </div>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory';

  const StaffRepository = RepositoryFactory.get('staff');
  export default {
    name: "CurrencySettings",
    data() {
      return {
        currencies: []
      }
    },
    methods: {
      async fetchCurrencies() {
        this.$vs.loading()
        const {data} =  (await StaffRepository.getCurrencyList()).data
        this.currencies = data
        this.$vs.loading.close()
      }
    },
    async mounted() {
      await this.fetchCurrencies()
    }
  }
</script>

<style scoped>

</style>
